import { InvalidUrlError } from '@execonline-inc/url';
import { HttpError } from 'ajaxian';
import { AppyError, MissingApiCompatibility, MissingApplicationId } from '../../../../../../Appy';
import { MissingLinkError } from '../../../../../../LinkyLinky';
import { Resource, ValidationError } from '../../../../../../Resource/Types';
import { TPlainTextKey } from '../../../../../../Translations';
import { License } from '../Types';

export interface Collection {
  id: number;
  name: string;
  learningDesignCount: number;
}

export interface Member {
  id: number;
  firstName: string;
  lastName: string;
  email: string;
}

export interface UserGroupWithAssociations {
  id: number;
  name: string;
  organization: string;
  organizationId: number;
  memberCount: number;
  assignedLicenseCount: number;
  assignedLicenseIds: number[];
  associatedLicenseIds: number[];
  collections: Collection[];
  members: Member[];
  status?: string;
}

export interface ParticipantOptions {
  userGroups: UserGroupWithAssociations[];
  licenses: License[];
  canAddAsAuditor: boolean;
}

export type ParticipantOptionsResource = Resource<ParticipantOptions>;

export interface Waiting {
  kind: 'waiting';
}

export interface Loading {
  kind: 'loading';
}

export interface Ready {
  kind: 'ready';
  participantOptionsResource: ParticipantOptionsResource;
}

export interface Error {
  kind: 'error';
  message: TPlainTextKey;
}

export type ParticipantOptionsState = Waiting | Loading | Ready | Error;

export type ParticipantOptionError =
  | HttpError
  | MissingLinkError
  | MissingApplicationId
  | MissingApiCompatibility
  | AppyError
  | Error
  | ValidationError
  | InvalidUrlError;

export const waiting = (): Waiting => ({
  kind: 'waiting',
});

export const loading = (): Loading => ({
  kind: 'loading',
});

export const ready = (participantOptionsResource: ParticipantOptionsResource): Ready => ({
  kind: 'ready',
  participantOptionsResource,
});
